export default function AdminLayout({ children }) {
    return (
        <div className="min-h-screen bg-gray-100">
            <div className="p-4">
                {children}
            </div>
        </div>
    );
}